/* import __COLOCATED_TEMPLATE__ from './custom-information.hbs'; */
/* RESPONSIBLE TEAM: team-integration-apps */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class CustomInformation extends Component {
  @service declare intercomEventService: any;

  @action
  trackAnalyticsEvent(data: TrackAnalyticsEventParms): void {
    let { action, object } = data;
    this.intercomEventService.trackAnalyticsEvent({
      action,
      object,
      section: 'app_settings',
      context: 'shopify',
      place: 'onboarding',
    });
  }
}

interface TrackAnalyticsEventParms {
  action: string;
  object: string;
  metadata?: any;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Appstore::AppPackage::Settings::Shopify::CustomInformation': typeof CustomInformation;
  }
}
